export const MATERIALS_FEATURE_KEY = 'materials';
